export default {"src":"/_next/static/media/tag.6b15c0d7.svg","height":15,"width":15};